window.__tnt || (window.__tnt = {});
window.__tnt.pay || (window.__tnt.pay = {});
window.__tnt.pay.method || (window.__tnt.pay.method = {});

// init - runs at form init
// submitPayment - runs when the user clicks the pay button (if this is selected)

__tnt.pay.method.wallet = {
    name: "wallet",
    methodString: "Credit Card",
    init: function(pf) {
        var payMethodSelect = pf.querySelector('.tn-pay-method-select'),
            payMethodSelectOutput = null,
            payMethodSelectNewCard = null;

        if (__tnt.user && __tnt.user.authToken) {
            var walletPromise = new Promise(function (resolve, reject) {
                var walletResolve = resolve,
                    walletReject = reject;

                pf.FormInitPromises.push(fetch('/tncms/pay/wallet/list/', {
                    method: 'get',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then(function(oResp){
                    if(oResp.ok){ oResp.json().then(function(oData){
                        var searchParams = new URLSearchParams(window.location.search),
                            renewalToken = pf.dataset.renewalToken,
                            dateTime = new Date(),
                            walletTest,
                            testToken;

                        if (searchParams.has('debug') && searchParams.has('wallet_test')) {
                            walletTest = searchParams.get('wallet_test');
                            renewalToken = "[RENEWAL TOKEN]";
                            testToken = "[TEST TOKEN]";

                            pf.dataset.renewalToken = renewalToken;

                            switch (walletTest) {

                                case "wallet_empty":
                                    oData.items = [];
                                    console.warn('DEBUG - WALLET - wallet_empty', oData.items);
                                    break;

                                case "wallet_expired_default":
                                    oData.items = [{"id":renewalToken,"is_default":true,"type":"card","month":(dateTime.getMonth()-1),"year":dateTime.getFullYear(),"card_type":"visa","last_four_digits":"1111"}];
                                    console.warn('DEBUG - WALLET - wallet_expired_default', oData.items);
                                    break;

                                case "wallet_expired":
                                    oData.items = [{"id":renewalToken,"is_default":false,"type":"card","month":(dateTime.getMonth()-1),"year":dateTime.getFullYear(),"card_type":"visa","last_four_digits":"1111"}];
                                    console.warn('DEBUG - WALLET - wallet_expired', oData.items);
                                    break;

                                case "wallet_other_expired":
                                    oData.items = [{"id":testToken,"is_default":false,"type":"card","month":8,"year":2022,"card_type":"master","last_four_digits":"4444"},{"id":renewalToken,"is_default":false,"type":"card","month":dateTime.getMonth(),"year":(dateTime.getFullYear()+1),"card_type":"visa","last_four_digits":"1111"}];
                                    console.warn('DEBUG - WALLET - wallet_other_expired', oData.items);
                                    break;

                                case "wallet_method_expired":
                                    oData.items = [{"id":testToken,"is_default":false,"type":"card","month":dateTime.getMonth(),"year":(dateTime.getFullYear()+1),"card_type":"master","last_four_digits":"4444"},{"id":renewalToken,"is_default":false,"type":"card","month":8,"year":2022,"card_type":"visa","last_four_digits":"1111"}];
                                    console.warn('DEBUG - WALLET - wallet_method_expired', oData.items);
                                    break;

                                case "wallet_expiring":
                                    oData.items = [{"id":renewalToken,"is_default":false,"type":"card","month":(dateTime.getMonth()+1),"year":dateTime.getFullYear(),"card_type":"visa","last_four_digits":"1111"}];
                                    console.warn('DEBUG - WALLET - wallet_expiring', oData.items);
                                    break;

                                case "wallet_other_expiring":
                                    oData.items = [{"id":testToken,"is_default":false,"type":"card","month":(dateTime.getMonth()+1),"year":dateTime.getFullYear(),"card_type":"master","last_four_digits":"4444"},{"id":renewalToken,"is_default":false,"type":"card","month":dateTime.getMonth(),"year":(dateTime.getFullYear()+1),"card_type":"visa","last_four_digits":"1111"}];
                                    console.warn('DEBUG - WALLET - wallet_other_expiring', oData.items);
                                    break;

                                case "wallet_bad_card":
                                    oData.items = [{"id":testToken,"is_default":false,"type":"card","month":dateTime.getMonth(),"year":(dateTime.getFullYear()+2),"card_type":"CREDIT","last_four_digits":"4444"},{"id":renewalToken,"is_default":false,"type":"card","month":dateTime.getMonth(),"year":(dateTime.getFullYear()+1),"card_type":"visa","last_four_digits":"1111"}];
                                    console.warn('DEBUG - WALLET - wallet_bad_card', oData.items);
                                    break;

                                case "wallet_very_bad_card":
                                    oData.items = [{"id":null,"is_default":false,"type":"card","month":dateTime.getMonth(),"year":(dateTime.getFullYear() + 2),"card_type":null,"last_four_digits":null},{"id":renewalToken,"is_default":false,"type":"card","month":dateTime.getMonth(),"year":(dateTime.getFullYear()+1),"card_type":"visa","last_four_digits":"1111"}];
                                    console.warn('DEBUG - WALLET - wallet_very_bard_card', oData.items);
                                    break;

                               case "paypal":
                                   oData.items = [{"id":renewalToken,"is_default":true,"type":"sprel","month":null,"year":null,"last_four_digits":null}];
                                   console.warn('DEBUG - WALLET - paypal', oData.items);
                                   break;

                               case "applepay":
                                   oData.items = [{"id":renewalToken,"is_default":true,"type":"applepay","month":null,"year":null,"last_four_digits":null}];
                                   console.warn('DEBUG - WALLET - applepay', oData.items);
                                   break;

                               case "googlepay":
                                   oData.items = [{"id":renewalToken,"is_default":true,"type":"googlepay","month":null,"year":null,"last_four_digits":null}];
                                   console.warn('DEBUG - WALLET - googlepay', oData.items);
                                   break;

                                default:
                                    console.warn('DEBUG - WALLET', oData.items);

                            }
                        }
                        // end debug specific code

                        var payMethodSelectWrapper = pf.querySelector('.tn-pay-method-select'),
                            templateEl = null,
                            outputEl = null,
                            iconsEl = document.getElementById('tn-pay-card-templates'),
                            expiringNotification = null,
                            expiredNotification = null,
                            dateCheck = new Date(),
                            filteredItems = [],
                            uniqueItems = [],
                            limitedItems = [],
                            templatePromises = [],
                            methodExpired = false;

                        if (payMethodSelectWrapper && oData && oData.items && oData.items.length) {
                            templateEl = payMethodSelectWrapper.querySelector('template.wallet-template');
                            outputEl = payMethodSelectWrapper.querySelector('.tn-pay-method-output');
                            expiringNotification = payMethodSelectWrapper.querySelector('.wallet-expiring-notification');
                            expiredNotification = payMethodSelectWrapper.querySelector('.wallet-expired-notification');

                            if (pf.dataset.walletExpiring) expiringNotification = document.getElementById(pf.dataset.walletExpiring);
                            pf.dataset.foundWallet = true;

                            if (outputEl) { outputEl.innerHTML = "" }

                            // @TODO - all this filtering code can hopefully be removed in the future
                            // Sort Items by Expiration Date in descending order (card furthest in the future will be first)
                            oData.items.sort(function(itemA, itemB){
                                if ((itemA.year < itemB.year) || ((itemA.year == itemB.year) && (itemA.month < itemB.month))) return 1;

                                return -1
                            });

                            // If a renewal token exists, sort the matching item to be the first option presented
                            if (renewalToken) {
                                oData.items.sort(function(itemA, itemB){
                                    if (itemA.id != renewalToken && itemB.id == renewalToken) return 1;
                                    if (itemA.id == renewalToken && itemB.id != renewalToken) return -1;

                                    return 1;
                                });
                                if (oData.items[0].is_default) {
                                    if (oData.items[0] && oData.items[0].type)  pf.dataset.renewalMethod = oData.items[0].type;

                                    if ((oData.items[0].year < dateCheck.getUTCFullYear()) || ((oData.items[0].year == dateCheck.getUTCFullYear()) && (oData.items[0].month <= dateCheck.getUTCMonth()))) {
                                        pf.dataset.foundDefault = true;
                                    }
                                }
                            }

                            // filter out cards with expired dates
                            filteredItems = oData.items.filter(function(item){
                                if ((item.year > dateCheck.getUTCFullYear()) || ((item.year == dateCheck.getUTCFullYear()) && (item.month > dateCheck.getUTCMonth()))){ return true }

                                return false;
                            });

                            // filter out cards with the same card_type and last four
                            filteredItems = filteredItems.filter(function(item){
                                if (item.type == "card" && item.last_four_digits && uniqueItems.indexOf(item.last_four_digits) < 0) { uniqueItems.push(item.last_four_digits); return true; }

                                return false;
                            });

                            // limit to the most recent - pass this variable somehow
                            limitedItems = filteredItems.slice(0,3);

                            if(limitedItems.length){
                                pf.dataset.walletItems = limitedItems.length;

                                limitedItems.forEach(function(item){
                                    var cardType = "credit card",
                                        cardIcon = null,
                                        cardIconEl = null,
                                        cardTypeIconEl = null,
                                        cardLabel = "Credit Card",
                                        expClass = "tn-cc-exp text-muted";
                                        
                                    if (iconsEl) {
                                        cardIconEl = iconsEl.querySelector('template[data-card=other]');

                                        if (item.card_type) cardTypeIconEl = iconsEl.querySelector('template[data-card-spreedly="' + item.card_type + '"]');
                                        if (cardTypeIconEl) cardIconEl = cardTypeIconEl;

                                        if (cardIconEl) {
                                            cardLabel = cardIconEl.dataset.card;
                                            cardIcon = cardIconEl.content.cloneNode(true);
                                        }
                                    }

                                    if(item.year == dateCheck.getUTCFullYear() && item.month <= (dateCheck.getUTCMonth()+1)){
                                        expClass = "tn-cc-exp text-warning"
                                    }

                                    var elements = [
                                        {
                                            'element' : '.tn-cc-label',
                                            'html' : cardLabel
                                        }, {
                                            'element' : '.tn-cc-last-four',
                                            'html' : item.last_four_digits
                                        }, {
                                            'element' : '.tn-cc-exp',
                                            'attr' : [
                                                {
                                                    'attr' : 'class',
                                                    'value' : expClass
                                                }
                                            ],
                                            'html' : " Exp " + item.month + "/" + item.year
                                        }
                                    ];

                                    if (item.is_default) {
                                        elements.push({
                                            'element': 'a.btn',
                                            'attr' : [
                                                {
                                                    'attr': 'data-token',
                                                    'value': JSON.stringify(item)
                                                },
                                                {
                                                    'attr': 'data-is-default',
                                                    'value': "true"
                                                }
                                            ]
                                        });
                                    } else {
                                        elements.push({
                                            'element': 'a.btn',
                                            'attr' : [
                                                {
                                                    'attr': 'data-token',
                                                    'value': JSON.stringify(item)
                                                }
                                            ]
                                        });
                                    }

                                    var templatePromise = new Promise(function(resolve, reject){
                                        __tnt.template(
                                            templateEl,    // template element
                                            outputEl,      // output element
                                            false,         // add items from start of output
                                            elements,      // elements in template to modify
                                            function (t) { // callback to run after template is added
                                                if (!payMethodSelect.classList.contains('tn-pay-method-found')) {
                                                    payMethodSelect.classList.add('tn-pay-method-found');
                                                }

                                                var link = t.querySelector('a'),
                                                    cardIconSVG = null;

                                                if(cardIcon){
                                                    cardIconSVG = document.importNode(cardIcon, true);
                                                    t.querySelector('a .tn-cc-lg').appendChild(cardIconSVG);
                                                }

                                                // In renewal mode highlight the previously used payment method
                                                if(item.id==renewalToken){
                                                    if (pf) pf.dataset.displayedDefault = true;
                                                    if(expiringNotification && item.year == dateCheck.getUTCFullYear() && item.month <= dateCheck.getUTCMonth()+1){
                                                        expiringNotification.hidden = false;
                                                        expiringNotification.classList.remove('fade');
                                                    }
                                                }

                                                link.dataset.paymentMethodEventLabel = __tnt.pay.method.wallet.methodString;

                                                link.classList.add("tn-pay-method");
                                                if (link.dataset.isDefault){
                                                    link.classList.add('tn-pay-method-selected');

                                                    token = JSON.parse(link.dataset.token);

                                                    pf.dataset.paymentMethod = "wallet";
                                                    if (pf.dataset.walletEndpoint) pf.action = pf.dataset.walletEndpoint;
                                                    __tnt.pay.setPaymentMethod(pf, "wallet", link, token);

                                                    __tnt.subscription.offers.logPaymentInfoEntered({
                                                        step: __tnt.subscription.offers.getPurchaseStep('payment_info'),
                                                        paymentMethod: __tnt.pay.method.wallet.methodString
                                                    });
                                                }

                                                link.addEventListener('click',function(ev){
                                                    var token = null;

                                                    try {
                                                        if(this.dataset && this.dataset.token){
                                                            token = JSON.parse(this.dataset.token);
                                                        }
                                                    } catch(e){ }

                                                    var addNewCardEl = pf.querySelector('.tn-pay-method-new-card'),
                                                        cardEntryEl = pf.querySelector('.tn-pay-card-entry');

                                                    cardEntryEl.hidden = true;
                                                    if(pf){
                                                        pf.dataset.paymentMethod = "wallet";

                                                        if (pf.dataset.walletEndpoint) pf.action = pf.dataset.walletEndpoint;
                                                    }

                                                    __tnt.pay.setPaymentMethod(pf, "wallet", this, token);

                                                    __tnt.subscription.offers.logPaymentInfoEntered({
                                                        step: __tnt.subscription.offers.getPurchaseStep('payment_info'),
                                                        paymentMethod: __tnt.pay.method.wallet.methodString
                                                    });
                                                });

                                                link.addEventListener('BLOXPaymentMethodSet', function() {
                                                    __tnt.subscription.offers.logPaymentInfoEntered({
                                                        step: __tnt.subscription.offers.getPurchaseStep('payment_info'),
                                                        paymentMethod: __tnt.pay.method.wallet.methodString
                                                    });
                                                });

                                                resolve({ complete: true });
                                            }
                                        );
                                    }); // template promise

                                    templatePromises.push(templatePromise);
                                }); // end of items loop

                                Promise.all(templatePromises).then(function(){
                                    walletResolve({ complete: true });
                                });

                            } else { walletResolve({ complete: true }) } // no items left after filter
                            
                        } else { walletResolve({ complete: true }) } // no items found

                    }).catch(function(error){
                        console.error(error);

                        var message = "An error occurred";
                        if (error && error.message) message += ": " + error.message;

                        var httpStatus = null;
                        if (oResp.status) httpStatus = oResp.status;

                        var httpStatusFatal = false;
                        if (oResp.status > 499) httpStatusFatal = true;

                        window.dispatchEvent(new CustomEvent('BLOXException', { 
                            'bubbles': true,
                            'detail': {
                                'description': message,
                                'http_status': httpStatus,
                                'fatal': httpStatusFatal,
                                'error_code': "WalletListResponseError",
                                'category': "subscription",
                            }
                        }));

                        walletResolve({ complete: true });
                    }); } else { pf.dataset.walletItems = 0 } // end of data
                }).catch(function(error){
                    console.error(error);

                    var message = "An error occurred";
                    if (error && error.message) message += ": " + error.message;

                    var httpStatus = null;
                    var httpStatusFatal = false;

                    window.dispatchEvent(new CustomEvent('BLOXException', { 
                        'bubbles': true,
                        'detail': {
                            'description': message,
                            'http_status': httpStatus,
                            'fatal': httpStatusFatal,
                            'error_code': "WalletListFetchError",
                            'category': "subscription",
                        }
                    }));

                    walletResolve({ complete: true });
                }) ); // end fetch wrapper promise

            });

            pf.FormInitPromises.push(walletPromise);

            Promise.all(pf.FormInitPromises).then(function() {
                var expiringNotification = null,
                    expiredNotification = null,
                    thirdPartyPaymentNotification = null,
                    renewalToken = null,
                    renewalMethod = "",
                    foundWallet = false,
                    foundDefault = false,
                    displayedDefault = false,
                    walletItems = 0;

                if (pf) {
                    renewalToken = pf.dataset.renewalToken;
                    renewalMethod = pf.dataset.renewalMethod;
                    if (pf.dataset.walletExpired) expiredNotification = document.getElementById(pf.dataset.walletExpired);
                    if (pf.dataset.walletExpiring) expiringNotification = document.getElementById(pf.dataset.walletExpiring);
                    if (pf.dataset.walletRenewalThirdParty) thirdPartyPaymentNotification = document.getElementById(pf.dataset.walletRenewalThirdParty);
                    if (pf.dataset.walletItems) walletItems = pf.dataset.walletItems;
                    if (pf.dataset.foundWallet) foundWallet = true;
                    if (pf.dataset.foundDefault) foundDefault = true;
                    if (pf.dataset.displayedDefault) displayedDefault = true;

                    /* renewal mode */
                    if (renewalToken && renewalMethod) {
                        if(thirdPartyPaymentNotification && foundDefault && renewalMethod != "card") {
                            if (renewalMethod == "sprel") {
                                thirdPartyPaymentNotification.querySelector('.renewal-method').innerHTML = "PayPal";

                            } else if (renewalMethod == "applepay") {
                                thirdPartyPaymentNotification.querySelector('.renewal-method').innerHTML = "Apple Pay";

                            } else if (renewalMethod == "googlepay") {
                                thirdPartyPaymentNotification.querySelector('.renewal-method').innerHTML = "Google Pay";
                            }

                            thirdPartyPaymentNotification.hidden = false;
                            thirdPartyPaymentNotification.classList.remove('fade');

                        } else if (expiredNotification && !displayedDefault) {
                            expiredNotification.hidden = false;
                            expiredNotification.classList.remove('fade');
                        }

                    } else if (renewalToken) {
                        if(expiredNotification && foundWallet && !displayedDefault){
                            expiredNotification.hidden = false;
                            expiredNotification.classList.remove('fade');
                        }
                    }
                }
            });
            // end renewal-only code

        } // user check
    }, // end init
    submitPayment: function(pf) {
        try {
            var purchaseEndpoint = pf.action,
                recaptchaAction = 'subscribe';
            
            if (purchaseEndpoint.includes('swapcard')) recaptchaAction = 'subscription_swap_payment_method';

            grecaptcha.enterprise.ready(function(){
                grecaptcha.enterprise.execute(pf.dataset.captchaKey, {action: recaptchaAction}).then(function(vkToken){
                    const oData = new FormData();

                    // Endpoint
                    var purchaseEndpoint = pf.action;

                    if (purchaseEndpoint == window.location.origin + pf.dataset.walletEndpoint) {
                        oData.append('tnpay-token', pf['tnpay-token'].value);
                        oData.append('transaction_id', pf['transaction_id'].value);
                    } else {
                        for (const aPair of new FormData(pf)) {
                            oData.append(aPair[0], aPair[1]);
                        }
                    }

                    oData.append('tncms_csrf_token', pf['tncms_csrf_token'].value);
                    oData.append('recaptcha_token', vkToken);

                    tntPaymentSubmitted.detail = {};
                    pf.dispatchEvent(tntPaymentSubmitted);

                    fetch(purchaseEndpoint, {
                        method: 'post',
                        credentials: 'include',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: oData
                    }).then(function(oResp){
                        oPayload = oResp.json().then(function(oPayload){
                            if (oPayload.transaction_id){
                                var oProductData = __tnt.subscription.offers.getProduct(),
                                    date = new Date();

                                const successDetails = {
                                    payload: oPayload,
                                    transactionData: {
                                        transaction_id: oPayload.transaction_id,
                                        start_date: date.getTime(),
                                        tax: Number(oPayload.tax_assessed / 100) // normalizing to dollars since the server response is in cents
                                    }
                                };

                                if (oProductData) {
                                    successDetails.transactionData.service_name = oProductData.name;
                                    successDetails.transactionData.service_rate = oProductData.variant;
                                    successDetails.transactionData.rate_price = oProductData.price;
                                    successDetails.transactionData.currency = oProductData.currency;
                                } else {
                                    console.warn("Product data not found");
                                }

                                const tntPaymentSuccess = new CustomEvent('tnt-payment-success', {
                                    bubbles: true,
                                    cancelable: true,
                                    detail: successDetails
                                });

                                pf.dispatchEvent(tntPaymentSuccess);

                                /* LOG PURCHASE COMPLETE EVENT */
                                __tnt.subscription.offers.logOrderCompleted(oPayload.transaction_id);

                            } else {
                                if (oPayload.success) {
                                    pf.dispatchEvent(
                                        new CustomEvent('tnt-payment-success', {
                                            bubbles: true,
                                            cancelable: true,
                                            detail: {
                                                payload: oPayload
                                            }
                                        })
                                    );

                                    if (oPayload.success && (oPayload.message == "Payment method added, and Transaction updated." || oPayload.message == "Payment method updated.")) {
                                        successScreen = document.getElementById('service-purchase-renewal-success');

                                        if (successScreen) {
                                            pf.hidden = true;
                                            successScreen.classList.remove('hide');
                                        }
                                    }

                                } else {
                                    tntPaymentError.detail = {};

                                    tntPaymentError.detail.message = "An error occurred";

                                    var message = "An error occurred"
                                    if (oPayload.message) {
                                        tntPaymentError.detail.message = oPayload.message;
                                        message =message + ": " + oPayload.message;
                                    }

                                    if (oPayload.original_rate && oPayload.resolved_rate) {
                                        tntPaymentError.detail.requires_confirmation = true;
                                        tntPaymentError.detail.original_rate = oPayload.original_rate;
                                        tntPaymentError.detail.resolved_rate = oPayload.resolved_rate;
                                    }

                                    var httpStatus = null;
                                    if (oResp.status) httpStatus = oResp.status;

                                    var httpStatusFatal = false;
                                    if (oResp.status > 499) httpStatusFatal = true;

                                    window.dispatchEvent(new CustomEvent('BLOXException', {
                                        'bubbles': true,
                                        'detail': {
                                            'description': message,
                                            'http_status': httpStatus,
                                            'fatal': httpStatusFatal,
                                            'error_code': "PayloadFailure",
                                            'category': "subscription",
                                            'payment_method': __tnt.pay.method.wallet.name,
                                            'payment_gateway': null,
                                            'ecommerce_channel': 'subscription'
                                        }
                                    }));

                                    pf.dispatchEvent(tntPaymentError);
                                }
                            }
                        }).catch(function(error){
                            console.error(error);

                            tntPaymentError.detail = {};
                            tntPaymentError.detail.message = "An error occurred";

                            var message = "An error occurred";
                            if (error && error.message) {
                                message = message + ": " + error.message;
                            }

                            var httpStatus = null;
                            if (oResp.status) httpStatus = oResp.status;

                            var httpStatusFatal = false;
                            if (oResp.status > 499) httpStatusFatal = true;

                            window.dispatchEvent(new CustomEvent('BLOXException', { 
                                'bubbles': true,
                                'detail': {
                                    'description': message,
                                    'http_status': httpStatus,
                                    'fatal': httpStatusFatal,
                                    'error_code': "ResponseError",
                                    'category': "subscription",
                                    'payment_method': __tnt.pay.method.wallet.name,
                                    'payment_gateway': null,
                                    'ecommerce_channel': 'subscription'
                                }
                            }));

                            pf.dispatchEvent(tntPaymentError);
                        });
                    }).catch(function(error){
                        console.error(error);

                        tntPaymentError.detail = {};
                        tntPaymentError.detail.message = "An error occurred";

                        var message = "An error occurred";
                        if (error && error.message) {
                            message = message + ": " + error.message;
                        }

                        window.dispatchEvent(new CustomEvent('BLOXException', { 
                            'bubbles': true,
                            'detail': {
                                'description': message,
                                'http_status': null,
                                'fatal': false,
                                'error_code': "FetchError",
                                'category': "subscription",
                                'payment_method': __tnt.pay.method.wallet.name,
                                'payment_gateway': null,
                                'ecommerce_channel': 'subscription'
                            }
                        }));

                        pf.dispatchEvent(tntPaymentError);
                    });
                }).catch(function(error){
                    console.error(error);

                    tntPaymentError.detail = {};
                    tntPaymentError.detail.message = "An error occurred";

                    var message = "An error occurred";
                    if (error && error.message) message += ": " + error.message;

                    window.dispatchEvent(new CustomEvent('BLOXException', {
                        'bubbles': true,
                        'detail': {
                            'description': message,
                            'http_status': null,
                            'fatal': false,
                            'error_code': "GrecaptchaError",
                            'category': "subscription",
                            'payment_method': __tnt.pay.method.wallet.name,
                            'payment_gateway': null,
                            'ecommerce_channel': 'subscription'
                        }
                    }));

                    pf.dispatchEvent(tntPaymentError);
                });
            });

        } catch(error) {
            console.error(error);

            tntPaymentError.detail = {};
            tntPaymentError.detail.message = "An error occurred";

            var message = "An error occurred";
            if (error && error.message) message += ": " + error.message;

            window.dispatchEvent(new CustomEvent('BLOXException', { 
                'bubbles': true,
                'detail': {
                    'description': message,
                    'http_status': null,
                    'fatal': false,
                    'error_code': "GeneralPaymentError",
                    'category': "subscription",
                    'payment_method': __tnt.pay.method.wallet.name,
                    'payment_gateway': null,
                    'ecommerce_channel': 'subscription'
                }
            }));

            pf.dispatchEvent(tntPaymentError);
        }
    }
}
